export const mobileNumberWithPrefixRegex = new RegExp(/^\((\+673)\)\d{7}$/g);
export const fooRegex = new RegExp(/[\s\S]*/g);
